<template>
  <BContainer>
    <BRow>
      <BCol lg="11">
        <h2>Visual storytelling is an incredibly effective tool—and for good reason</h2>
        <p>Do your visuals deliver the impact you intend?</p>
      </BCol>
    </BRow>
    <BRow class="mt-3">
      <BCol
        class="text-center pr-lg-5"
        md="4"
      >
        <cld-image
          class="cloud-icon"
          public-id="v1557869975/state_of_visual_media/cloudinary-stopwatch.svg"
          alt="Icon of a stopwatch showing 0.013 second"
          width="60"
        />
        <p class="mx-lg-5">People can identify visual information after seeing it for as little as <strong>13 milliseconds.</strong><sup>1</sup></p>
        <span class="d-block my-3">
          <strong>What do people retain?</strong><sup>&nbsp;2</sup>
        </span>
        <BRow>
          <BCol
            class="text-center"
            align-h="center"
          >
            <ChartDonut
              :num="numbers.seen"
              class="chart-donut mb-2"
              chart-id="ChartDonut-seen"
            />
            <p class="px-lg-3">of seen information</p>
          </BCol>
          <BCol
            class="text-center"
            align-h="center"
          >
            <ChartDonut
              :num="numbers.read"
              class="chart-donut mb-2"
              chart-id="ChartDonut-read"
            />
            <p class="px-lg-3">of read information</p>
          </BCol>
        </BRow>
      </BCol>
      <BCol
        class="outline"
        md="8"
      >
        <ul>
          <li>
            <cld-image
              class="cloud-icon"
              public-id="v1557870014/state_of_visual_media/cloudinary-social.svg"
              alt="Icon showing two people with speech bubbles above their heads"
              fluid
              width="100"
            />
            <div class="content">
              <p>As social beings, we’re hardwired to sense emotions.</p>
              <!-- prettier-ignore -->
              <p>The <em>experience</em> a visual story creates becomes the key to its success.</p>
              <v-popover popover-class="pp-40">
                <LearnMore />
                <template slot="popover">
                  <div class="popover-title">
                    <cld-image
                      class="tooltip-finger-icon"
                      public-id="v1557870041/state_of_visual_media/cloudinary-finger.svg"
                      alt="Icon of a hand with the index finger pointing up, representing a tool tip"
                    />
                    <h4>Why does experience matter?</h4>
                  </div>
                  <b-row class="no-gutters pl-3">
                    <b-col class="px-1">
                      <ChartDonut
                        :dark="true"
                        :num="numbers.tooltip.purchase"
                        class="chart-donut"
                        chart-id="ChartDonut-purchase"
                      />
                      <!-- prettier-ignore -->
                      <p><strong>{{ numbers.tooltip.purchase }}%</strong> of purchase decisions are made subconsciously*</p>
                      <small class="d-block mt-4">*Nielson Company: Winnett and Pohlmann</small>
                    </b-col>
                    <b-col class="px-1">
                      <ChartDonut
                        :dark="true"
                        :num="numbers.tooltip.credibility"
                        class="chart-donut"
                        chart-id="ChartDonut-credibility"
                      />
                      <!-- prettier-ignore -->
                      <p>Nearly <strong>{{ numbers.tooltip.credibility }}%</strong> of people view visual impression as the #1 factor in credibility*</p>
                      <small class="d-block mt-4">*Stanford Persuasive Technology Lab</small>
                    </b-col>
                  </b-row>
                </template>
              </v-popover>
            </div>
          </li>
          <li>
            <cld-image
              class="cloud-icon"
              public-id="v1557870074/state_of_visual_media/cloudinary-report.svg"
              alt="Icon with an eye and a paperclip on a piece of paper, identifying the State of Visual Media Report"
              fluid
              width="100"
            />
            <div class="content">
              <p>Cloudinary’s inaugural State of Visual Media Report was developed to help marketers and technologists alike better understand how visual content is being viewed and consumed.</p>
            </div>
          </li>
          <li>
            <cld-image
              class="cloud-icon"
              public-id="v1557870096/state_of_visual_media/cloudinary-stories.svg"
              alt="Icon of a page with an arrow pointing right, showing how to continue reading the report"
              fluid
              width="100"
            />
            <div class="content">
              <p>Read on to discover how to create a more powerful experience and to uncover opportunities to improve the impact of visual stories.</p>
            </div>
          </li>
        </ul>
      </BCol>
    </BRow>
    <footer>
      <p class="small">Sources: MIT News , Nielsen Company, Stanford Persuasive Technology Lab</p>
    </footer>
  </BContainer>
</template>

<script>
import LearnMore from "../LearnMore.vue";
// import PopoverContent from "../PopoverContent.vue";
import ChartDonut from "../donut-filled.vue";

export default {
  components: {
    LearnMore,
    // PopoverContent,
    ChartDonut
  },
  props: {
    numbers: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
